
(($) => {
  if(typeof pageprocessos == 'undefined') {
    const cursos = $('.lista-cursos:visible .curso-info__cab').map((_, e) => ({
      value: $(e).find('.curso-info__cab-texto').text().replaceAll('\n', '').trim(),
      link: $(e).find('.curso-info__cab-link').attr('href'),
    })).get();

    let accentMap = {
      "á": "a",
      "é": "e",
      "í": "i",
      "ó": "o",
      "ú": "u",
      "â": "a",
      "ê": "e",
      "î": "i",
      "ô": "o",
      "û": "u",
      "à": "a",
      "è": "e",
      "ì": "i",
      "ò": "o",
      "ù": "u",
      "ã": "a",
      "õ": "o"
    };

    let normalize = function (term) {
      let ret = "";
      for (let i = 0; i < term.length; i++) {
        ret += accentMap[term.charAt(i)] || term.charAt(i);
      }
      return ret;
    };

    $('#encontre_curso').autocomplete({
      // source: cursos,
      source: function (request, response) {
        let matcher = new RegExp($.ui.autocomplete.escapeRegex(request.term), "i");
        response($.grep(cursos, function (value) {
          value = value.label || value.value || value;
          return matcher.test(value) || matcher.test(normalize(value));
        }));
      },
      select: (_, ui) => {
        location.href = ui.item.link;
      },
    });

    $(".search-field").on('submit', e => {
      e.preventDefault()
      $("#encontre_curso_btn").click()
    })

    $('.input-group-append').on('click', function () {
      if ($(".ui-helper-hidden-accessible:contains('available')").length > 0) {
        const items = $(".ui-menu-item")
        for (let i = 0; i < items.length; i++) {
          if (items[i].outerText.toLowerCase() === $("#encontre_curso").val().toLowerCase()) {
            items[i].click()
          }
        }
        $(".ui-menu-item").first().click()
      } else {
        let selected = $(".ui-helper-hidden-accessible > div").text()
        $(".ui-menu-item > div:contains(" + selected + ")").click()
      }
    });

    $('.encontre-curso').on('change', function () {
      const url = $(this.options[this.selectedIndex]).data('url');
      if (!url) return;
      location.href = url;
    });

    const $mods = $('.encontre-filtros:visible .checkbox__field');
    $mods.on('click', function () {
      const $modsGrupo = $(this).closest('.encontre-filtros').find('.checkbox__field');
      if (this.checked) {
        if ($(this).hasClass('encontre-filtros__all')) {
          $modsGrupo.not(this).prop('checked', false);
        } else {
          $modsGrupo.filter('.encontre-filtros__all').prop('checked', false);
        }
      } else if ($(this).hasClass('encontre-filtros__all')) {
        this.checked = true;
      } else if ($modsGrupo.filter(':checked').length === 0) {
        $modsGrupo.filter('.encontre-filtros__all').prop('checked', true);
      }
      filtrar();
    });
    filtrar();
    docentes_seletor();

    function filtrar() {
      const $relevantes = $mods.filter(':checked');
      const filtros = $.map($relevantes, (el) => $(el).data('filtro'));
      $('.curso-info').each(function (_, el) {
        const campos = $(el).data('campos');
        const matches = {};
        for (const campo of Object.keys(campos)) {
          matches[campo] = false;
        }

        for (const filtro of filtros) {
          if (Array.isArray(campos[filtro.campo])) {
            if(filtro.all ||  campos[filtro.campo][0].includes(filtro.label)){matches[filtro.campo] = true;}
          }
          else if (filtro.all ||  campos[filtro.campo].includes(filtro.label) ) {
            matches[filtro.campo] = true;
          }
        }

        $(el).show();
        for (const match of Object.values(matches)) {
          if (!match) {
            $(el).hide();
          }
        }
      });
    }

    function docentes_seletor() {
      const $seletor = $('#corpo-docente-seletor');
      if ($seletor.length === 0) return;

      $seletor.on('change', function () {
        const $load = $('#corpo-docente-load');
        $load.html('<h5>Carregando...</h5>');
        $.get($seletor.val()).then(
          (response) => $load.html($(response).find('#corpo-docente-load').html()),
          () => $load.html('<h5>Erro ao carregar dados.</h5>'),
        );
      });
    }
  }
})(jQuery);

